<template>
    <div id="custom-edit">
        <Breadcrumb></Breadcrumb>

        <div style="text-align: right;margin-top: 10px">
            <el-button type="warning" @click="saveUpdate('03')" size="small">保存到待发布</el-button>
            <el-button type="success" @click="saveUpdate('01')" size="small">立即发布</el-button>
        </div>

        <el-form :model="form" ref="form" label-width="100px" :rules="rules" id="form">

            <div class="t_plane self_el_item_form">
                <div class="pl_til">产品信息</div>
                <div class="pl_content">
                    <el-form-item label="中文标题:"  prop="proTitle">
                        <el-input v-model="form.proTitle" class="inputSize" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="英文标题:" style="margin-top: 20px">
                        <el-input v-model="form.engProTitle" class="inputSize" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="产品分类" style="margin-top: 20px" prop="typeId">
                        <el-cascader v-model="form.typeId" :options="typeOptions" :show-all-levels="false" size="small"></el-cascader>
                    </el-form-item>
                    <el-form-item label="生产工艺" style="margin-top: 20px" prop="prodTech">
                        <el-input v-model="form.prodTech" class="inputSize" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="产品材质" style="margin-top: 20px" prop="pdMaterial">
                        <el-input v-model="form.pdMaterial" class="inputSize" size="small"></el-input>
                    </el-form-item>
                </div>
            </div>
            <!--SKU信息-->
            <div class="t_plane self_el_item_form">
                <div class="pl_til">SKU信息</div>
                <div class="pl_content">
                    <el-form-item label="生成变种:" ></el-form-item>
                    <el-row v-for="(item,index) in form.attributeList" style="margin-top: 10px">
                        <!--                        <el-col :span="1" style="text-align: right">-->
                        <!--                        </el-col>-->
                        <el-col :span="4" style="text-align: right;display: flex">
                            <i class="el-icon-remove-outline" style="font-size: 20px;margin: auto;color: #8071c9;cursor: pointer" @click="deleteAttrName(index)"></i>
                            <el-input
                                    @blur="handleName(index)"
                                    v-model.trim="item.attributeName"
                                    size="small" placeholder="属性名,如:Color"
                                    style="width: 200px;"></el-input>
                        </el-col>
                        <el-col :span="8">
                            <!--标签-->
                            <el-tag style="margin: 0 5px" type="warning" :key="tag" v-for="tag in item.dynamicTags" closable :disable-transitions="false"
                                    @close="handleClose(tag,index)">
                                {{tag}}
                            </el-tag>
                            <el-input
                                    class="input-new-tag"
                                    v-if="item.inputVisible"
                                    v-model.trim="item.attributeValue"
                                    ref="saveTagInput"
                                    size="small"
                                    style="width: 100px"
                                    @keyup.enter.native="handleInputConfirm(index)"
                                    @blur="handleInputConfirm(index)"
                            >
                            </el-input>
                            <el-button v-else type="primary" plain class="button-new-tag" size="small" @click="showInput(index)">+添加新属性值</el-button>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 10px;padding-left: 20px">
                        <el-button type="primary" class="button-new-tag" size="small" @click="addAttribute">+添加新属性</el-button>
                    </el-row>
                    <el-row style="margin-top: 10px">
                        <el-form-item label="编辑变种:" v-show="form.tableData.length>0" ></el-form-item>
                    </el-row>
                    <div style="margin-top: 10px">
                        <el-table id="table" ref="multipleTable" :data="form.tableData"
                                  style="width: 100%" @selection-change="handleSelectionChange" v-show="form.tableData.length>0">
                            <!--<el-table-column type="selection" width="40" align="center"></el-table-column>-->
                            <el-table-column prop="picUrl" label="图片"  align="center">
                                <template slot-scope="scope">
                                    <!--http-request如果想处理额外参数,则在方法里面再调用方法-->
                                    <el-upload
                                            :show-file-list="false"
                                            class="upload-demo"
                                            :limit="5"
                                            action="#"
                                            multiple
                                            :http-request="function (res) { return handleParam(res, scope.$index)}">
                                        <div v-show="scope.row.picUrl==''">
                                            <i class="el-icon-plus" style="font-size: 25px"></i>
                                        </div>
                                        <img v-show="scope.row.picUrl!=''" style="width: 80px;height: 110px;object-fit: contain" :src="scope.row.picUrl" />
                                    </el-upload>

                                </template>
                            </el-table-column>
                            <el-table-column prop="varAttr" label="变种信息" align="center">
                                <template slot-scope="scope">
                                    <el-form-item label-width="10px" >
                                        <span>{{scope.row.varAttr}}</span>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="SKU"  align="center">
                                <template slot="header" slot-scope="scope">
                                    <el-row>SKU</el-row>
                                    <el-row>
                                        <el-button type="text" @click="updateSkuDig=true">(一键生成)</el-button>
                                    </el-row>
                                </template>
                                <template slot-scope="scope">
                                    <el-form-item label-width="10px"  :prop="'tableData.'+scope.$index+'.commSku'"   :rules='rules.commSku'>
                                        <el-input size="mini" v-model.trim="scope.row.commSku" placeholder="请输入内容"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column prop="price" label="价格"  align="center">
                                <template slot="header" slot-scope="scope">
                                    <el-row>价格</el-row>
                                    <el-row>
                                        <el-button type="text" @click="updatePriceDig = true">(修改)</el-button>
                                    </el-row>
                                </template>
                                <template slot-scope="scope">
                                    <el-form-item label-width="10px" :prop="'tableData.'+scope.$index+'.price'"   :rules='rules.price'>
                                        <el-input size="mini" v-model.trim="scope.row.price" placeholder="请输入内容" ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="操作"  align="center">
                                <template slot-scope="scope">
                                    <el-form-item label-width="10px">
                                        <el-link type="primary" @click="deleteAttr(scope.row,scope.$index)">移除</el-link>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>

            <!--变种图片-->
            <div class="t_plane self_el_item_form">
                <div class="pl_til">变种图片</div>
                <div class="pl_content">
                    <!--<div style="text-align: center" v-show="form.tableData.length<1">暂无图片</div>-->
                    <el-form-item label="暂无图片"  style="text-align: center" v-show="form.tableData.length<1" ></el-form-item>
                    <div v-for="(item, index) in form.tableData">
                        <el-row>
                            <el-upload
                                    :show-file-list="false"
                                    :limit="5"
                                    class="upload-demo"
                                    action="#"
                                    multiple
                                    :http-request="function (res) { return skuUploadImg(res,index)}"
                                    v-show="item.skuPicList.length<5">
                                <el-link type="primary">点击上传图片</el-link>
                            </el-upload>
                        </el-row>
                        <!--商品信息说明-->
                        <div>
                            <el-row style="text-align: center">
                                <template v-for="(attr, index) in form.attributeList">
                                    <span v-if="attr.attributeName != null && attr.dynamicTags.length>0"  style="margin-right: 15px">{{attr.attributeName}}:{{item.attrList[index]}}</span>
                                </template>
                                <div style="margin-right: 15px">【{{item.skuPicList.length}}/5】图片</div>
                            </el-row>
                        </div>
                        <!--图片-->
                        <div>
                            <el-row>
                                <el-col :span="2" v-for="(item_2, img_index) in item.skuPicList" :key="img_index" style="margin-right: 20px">
                                    <el-card :body-style="{ padding: '5px'}">
                                        <el-popover trigger="hover" title="" placement="right">
                                            <img :src="item_2.imgUrl" style="width: 120px;height: 120px;object-fit: contain">
                                            <img slot="reference" :src="item_2.imgUrl" class="image" style="width: 120px;height: 120px;object-fit: contain">
                                        </el-popover>
                                        <div style="padding: 5px;">
                                            <el-row style="font-size: 5px">
                                                <el-link style="font-size: 5px;float: left">{{item_2.picPx}}</el-link>
                                                <el-link type="primary" style="font-size: 5px;float: right" @click="deleteSkuImg(index,img_index)">移除</el-link>
                                            </el-row>
                                        </div>
                                    </el-card>
                                </el-col>
                            </el-row>
                        </div>
                        <el-divider></el-divider>
                    </div>
                </div>
            </div>

            <!--包装信息-->
            <div class="t_plane self_el_item_form">
                <div class="pl_til">包装信息</div>
                <div class="pl_content">
                    <el-form-item label="重量:" prop="packWeight" style="margin-top: 15px">
                        <el-input
                                onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);"
                                v-model="form.packWeight"
                                style="width: 200px"
                                size="small">
                            <template slot="append">kg</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="包装尺寸:">
                        <el-input
                                @input="limitNumber($event,'long')"
                                onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{1,}/g,'');"
                                v-model="form.packLong"
                                placeholder="长"
                                style="width: 200px"
                                @change="setVolume"
                                size="small">
                            <template slot="append">cm</template>
                        </el-input>
                        <el-input
                                @input="limitNumber($event,'wide')"
                                onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{1,}/g,'');"
                                v-model="form.packWide"
                                placeholder="宽"
                                @change="setVolume"
                                style="width: 200px;margin-left: 20px"
                                size="small">
                            <template slot="append">cm</template>
                        </el-input>
                        <el-input
                                @input="limitNumber($event,'high')"
                                onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{1,}/g,'');"
                                v-model="form.packHigh"
                                placeholder="高"
                                @change="setVolume"
                                style="width: 200px;margin-left: 20px"
                                size="small">
                            <template slot="append">cm</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="包装体积:" style="margin-top: 15px">
                        <el-input
                                v-model="form.packVole"
                                style="width: 205px"
                                readonly
                                size="small">
                            <template slot="append">cm³</template>
                        </el-input>
                    </el-form-item>
                </div>
            </div>

            <!--描述信息-->
            <div class="t_plane self_el_item_form">
                <div class="pl_til">描述信息</div>
                <div class="pl_content">
                    <el-row>
                        <el-form-item label="产品描述:"> </el-form-item>
                        <span style="color: red;margin-left: 30px">
                            说明：描述区图片尺寸需小于5000x5000，图片大小不能超过3M!
                        </span>
                    </el-row>
                    <div style="margin-top: 25px;margin-bottom: 25px">
                        <CKEditor4 v-model="form.description" @getCkEditorInstance="getEditor1" :config="editorConfig"></CKEditor4>
                    </div>

                    <el-form-item label="产品尺寸:"> </el-form-item>
                    <div style="margin-bottom: 20px">
                        <CKEditor4 v-model="form.size" @getCkEditorInstance="getEditor2" :config="editorConfig"></CKEditor4>
                    </div>
                    <el-form-item  label="温馨提示:">
                        <el-input type="textarea" :rows="5" v-model="form.warmTip" placeholder="请输入内容" size="mini"></el-input>
                    </el-form-item>
                    <!--一键生成SKU弹框弹框-->
                    <el-dialog :close-on-click-modal="false"  
                            title="生成SKU"
                            :visible.sync="updateSkuDig"
                            width="30%"
                            
                            @close="cancelPrice">
                        <el-row style="margin-top: 15px;margin-left: 15px">
                            <el-form-item label-width="80px" label="前缀" >
                                <el-input v-model.trim="prefixSku"  placeholder="请输入内容" size="mini" style="width: 200px"></el-input>
                                <!--<el-input v-model.trim="prefixSku" onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);" placeholder="请输入内容" size="mini" style="width: 200px"></el-input>-->
                            </el-form-item>
                            <el-form-item label-width="80px" label="后缀" >
                                <el-input v-model.trim="suffixSku"  placeholder="请输入内容" size="mini" style="width: 200px"> </el-input>
                            </el-form-item>
                        <span>
                            说明：前缀=BG0001,后缀=CN,生成：BG0001-CN
                        </span>
                        </el-row>
                    <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelSku" size="small">取 消</el-button>
                    <el-button type="primary" @click="sumbitSku()" size="small">确 定</el-button>
                </span>
                    </el-dialog>
                    <!--修改价格弹框-->
                    <el-dialog :close-on-click-modal="false"  
                            title="修改价格"
                            :visible.sync="updatePriceDig"
                            width="30%"
                            
                            @close="cancelPrice">
                        <el-row style="margin-top: 15px;margin-left: 15px">
                            <el-form-item label-width="80px" label="价格" >
                                <el-input v-model.trim="price" onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');" placeholder="请输入内容" size="mini" style="width: 200px"></el-input>
                            </el-form-item>
                        </el-row>
                    <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelPrice" size="small">取 消</el-button>
                    <el-button type="primary" @click="sumbitPrice" size="small">确 定</el-button>
                </span>
                    </el-dialog>

                </div>
            </div>

        </el-form>

    </div>
</template>

<script type="text/ecmascript-6">
    import Breadcrumb from '@/components/common/Breadcrumb'
    import ElRow from "element-ui/packages/row/src/row";
    import {calcDescartes,toDecimal} from '@/utils/jn';
    import {goodsUploadImg} from '@/api/product/common';
    import CKEditor4 from '@/components/common/CKEditor'
    import {loadDataMap} from '@/api/tree/tree'
    import {updateProduct,getAllProductMsg} from '@/api/customProduct/custom'
    export default {
        name: "product",
        components:{
            ElRow,
            Breadcrumb,
            CKEditor4
        },
        data(){
            return{
                labelPosition: 'right',
                typeData:[],//原始分类数据
                typeOptions: [],//处理成树状结构的分类数据
                form:{
                    pId:'',
                    proTitle:'',
                    engProTitle: '',
                    typeId:'',
                    prodTech:'',
                    pdMaterial:'',
                    tableData:[

                    ],
                    attributeList: [],
                    design:{
                        imgUrl:null,
                        picPx:null,
                    },
                    price:null,
                    packWeight:null, //重量
                    packLong:null,   //长
                    packWide:null,   //宽
                    packHigh:null,   //高
                    packVole: null,
                    description:'', //产品描述
                    size:'', //产品尺寸
                    warmTip:'' //温馨提示
                },
                updateSkuDig:false, //一键生成SKU弹框
                prefixSku:null, //SKU前缀
                suffixSku:null, //SKU后缀
                updatePriceDig:false,//修改价格弹框
                price:null,//价格
                rules: {
                    proTitle: [
                        {required: true, message: '请输入中文标题', trigger: 'blur'},
                    ],
                    typeId: [
                        {required: true, message: '请选择产品分类', trigger: 'blur'},
                    ],
                    prodTech: [
                        {required: true, message: '请输入生产工艺', trigger: 'blur'},
                    ],
                    pdMaterial: [
                        {required: true, message: '请输入产品材质', trigger: 'blur'},
                    ],
                    price: [
                        { required: true, message: '请输入价格', trigger: 'blur' },
                    ],
                    commSku: [
                        { required: true, message: '请输入SKU', trigger: 'blur' },
                    ],
                    packWeight: [
                        { required: true, message: '请输入包装重量', trigger: 'blur' },
                    ],
                    packLong: [
                        { required: true, message: '请输入包装尺寸长', trigger: 'blur' },
                    ],
                    packWide: [
                        { required: true, message: '请输入包装尺寸宽', trigger: 'blur' },
                    ],
                    packHigh: [
                        { required: true, message: '请输入包装尺寸高', trigger: 'blur' },
                    ],
                },
                //生产天数
                options_2: [{
                    value: '选项1',
                    label: '1-3天'
                }, {
                    value: '选项2',
                    label: '3-5天'
                }, {
                    value: '选项3',
                    label: '5-7天'
                }, {
                    value: '选项4',
                    label: '大于7天'
                },
                ],
                editor1:null,
                editor2:null,
                editorConfig:{
                    // extraPlugins:'myplug',
                    height:'300px',
                    toolbar : [
                        [ 'Source','Maximize'],
                        [ 'Bold', 'Italic', 'Underline', 'Strike'],
                        [ 'TextColor', 'BGColor' ],
                        [  'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock','-','NumberedList', 'BulletedList', '-', 'Outdent', 'Indent',  '-','Subscript', 'Superscript'],
                        [ 'HorizontalRule','RemoveFormat'],
                        ['NewPage', 'Preview', '-', 'Undo', 'Redo' ],
                        '/',
                        [ 'Styles', 'Format', 'Font', 'FontSize' ],
                        [ 'Paste', 'PasteText', 'PasteFromWord','Table'],
                        [ 'Link', 'Unlink','-' ,'Image']
                    ],
                    language: 'zh-cn',
                    wordcount:{
                        showCharCount: true,
                    }
                },
            }
        },
        created() {},
        mounted(){
        this.loadTypeOptions();

        },
        methods:{
            setVolume(){
                if(this.form.packLong != null && this.form.packWide != null && this.form.packHigh != null){
                    this.form.packVole = this.form.packLong * this.form.packWide * this.form.packHigh;
                }else{
                    this.form.packVole = "";
                }
            },
            saveUpdate(dzStatus){
                let that = this;
                that.form.pId = that.$route.query.pId;
                that.form.dzStatus = dzStatus;
                let typeId = that.form.typeId;
                that.form.typeId = that.form.typeId[that.form.typeId.length - 1];
                that.form.selfType = "02";
                this.form.description = this.editor1.getData();
                this.form.szie = this.editor2.getData();
                let map ={};
                that.form.attributeList.forEach(item =>{
                    map[item.attributeName] = item.dynamicTags;
                });
                that.form.attribute = JSON.stringify(map);
                that.$refs["form"].validate((valid) => {
                    if (valid) {
                        updateProduct(that.form).then((data) => {
                            if(data.code == 200){
                                that.$message({
                                    type: 'success',
                                    message: data.msg
                                });
                                this.$router.replace('/product_mng/manage/normalGoods')
                            }else{
                                that.$message.error(data.msg);
                                that.form.typeId = typeId;
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
           loadTypeOptions(){
                let that = this;
                loadDataMap().then((res) => {
                    res.data.forEach((item) => {
                        item.label = item.name;
                        item.value = item.id;
                    });
                    that.loadProductData(res.data);
                    that.typeOptions = that.optionData(res.data);
                });
            },
            //处理树的数据结构
            optionData(data) {
                let cloneData = JSON.parse(JSON.stringify(data));      // 对源数据深度克隆
                return cloneData.filter(father => {                      // 循环所有项，并添加children属性
                    let branchArr = cloneData.filter(child => father.id == child.parentId);       // 返回每一项的子级数组
                    branchArr.length > 0 ? father.children = branchArr : '';  //给父级添加一个children属性，并赋值
                    return father.parentId == 1;      //返回第一层
                });
            },
            deleteAttrName(index){
                this.form.attributeList.splice(index,1);
                this.loadSku();
            },

            handleClose(tag,index){
                this.form.attributeList[index].dynamicTags.splice(this.form.attributeList[index].dynamicTags.indexOf(tag),1);
                this.loadSku();
            },

            handleInputConfirm(index) {
                var attributeName = this.form.attributeList[index].attributeName;
                if (attributeName==null || attributeName.replace(/[\s]/g, '')==''){
                    this.msgError("属性名不能为空");
                    this.inputHide(index);
                    return
                }
                //获取input的值
                var inputValue = this.form.attributeList[index].attributeValue;
                if (inputValue==null || inputValue.replace(/[\s]/g, '')==''){
                    this.inputHide(index);
                    return
                }
                //获取标签集合
                var dynamicTags = this.form.attributeList[index].dynamicTags;
                //是否包含这个值
                let b = dynamicTags.includes(inputValue);
                if (b && inputValue){
                    this.msgError(inputValue+"已存在");
                    this.inputHide(index);
                    return
                }
                if (inputValue) {
                    this.form.attributeList[index].dynamicTags.push(inputValue)
                }
                this.loadSku();
                this.inputHide(index);
            },
            showInput(index) {
                this.$set(this.form.attributeList[index], 'inputVisible', true)
                // this.inputVisible = true;
                this.$nextTick(_ => {
                    let saveTagInput = this.$refs.saveTagInput[0];
                    this.$refs.saveTagInput[0].focus();
                });
            },
            addAttribute(){
                for (var i=0 ; i<this.form.attributeList.length;i++){
                    if (this.form.attributeList[i].attributeName==null || this.form.attributeList[i].attributeName==' '){
                        this.msgError("请先填写新增的属性,再添加下一个");
                        return
                    }
                    if (this.form.attributeList[i].dynamicTags.length <=0){
                        this.msgError("请先填写属性值,再添加下一个");
                        return
                    }
                }
                this.form.attributeList.push(
                        {
                            attributeName:null,
                            attributeValue:null,
                            dynamicTags: [],
                            inputVisible: false,
                            inputValue: ''
                        }
                )
            },
            //覆盖默认上传行为
            handleParam(data,index){
                this.uploadByPicType(data,index)
            },
            //上传图片时,区分不同的图片类型参数
            uploadByPicType(data,index){
                var formData = new FormData();
                //文件
                formData.append("imageFile", data.file);
                goodsUploadImg(formData).then(res => {
                    if(res.code == 200){
                        this.$set(this.form.tableData[index], 'picUrl', res.data.img);
                        this.msgSuccess(res.msg);
                    }
                }).catch(err => {});
            },
            //移除属性
            deleteAttr(row,index){
                //删除表格的一条数据
                this.form.tableData.splice(index,1);
                //获取sku
                let commSku = row.commSku;
                //分割数组
                var commSkuList = commSku.split("-");
                //遍历数组
                for (var i=0; i<commSkuList.length; i++){
                    //取出对应的属性值
                    var commSku2 = commSkuList[i];
                    //定义好是否需要删除属性值的标志
                    var flag=false;
                    for (var j=0; j<this.form.tableData.length; j++){
                        //取出SKU
                        var commSku3 = this.form.tableData[j].commSku;
                        //分割成数组
                        var split = commSku3.split("-");
                        //取出i对应的索引
                        let split2 = split[i];
                        if (split2==commSku2){
                            flag=true;
                        }
                    }
                    if (!flag){
                        //获取对应的属性名
                        let attributeList = this.form.attributeList[i];
                        //取出属性值集合
                        let dynamicTags = attributeList.dynamicTags;
                        //遍历属性值,如果有对应的则删除掉,因为表格里已经没有数据了
                        for (var i2=0; i2<dynamicTags.length; i2++){
                            if (commSku2==attributeList.dynamicTags[i2]){
                                this.form.attributeList[i].dynamicTags.splice(i2,1);
                            }
                        }
                    }
                }
            },
            getEditor1(val){
                this.editor1 = val;
            },
            getEditor2(val){
                this.editor2 = val;
            },
            //表格checkbox选择
            handleSelectionChange(){

            },
            //清空属性名时提示的操作
            handleName(index){
                var attributeName = this.form.attributeList[index].attributeName;
                var dynamicTags = this.form.attributeList[index].dynamicTags
                if(attributeName==null || attributeName==""){
                    if (dynamicTags.length > 0){
                        this.$confirm('清空属性值会清空所有的属性名,你确定要清空吗', "警告", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        }).then(function() {
                            return true;
                        }).then(() => {
                            this.$set(this.form.attributeList[index], 'dynamicTags', []);
                            this.loadSku();
                            this.msgSuccess("清空成功");
                        }).catch(function() {});
                    }

                }

            },
            //动态增删SKU
            loadSku(){
                this.form.tableData=[];
                var attributeList = this.form.attributeList;
                //如果有多个则遍历添加
                var cartesianArray=[];
                for (var i=0; i<attributeList.length; i++){
                    const attr = attributeList[i];
                    if(attr.attributeName != null && attr.dynamicTags.length > 0){
                        //获取标签的集合
                        var dynamicTags2 = attr.dynamicTags;
                        // attributeName+=this.form.attributeList[i].attributeName+"*";
                        cartesianArray.push(dynamicTags2);
                    }
                }
                var calcDescartes2 = calcDescartes(cartesianArray);
                //变种信息
                var attributeName='';
                // 商品SKU
                var value ="";
                for (var i=0; i<calcDescartes2.length; i++){
                    //判断是不是数组
                    if (calcDescartes2[i].constructor==Array){
                        value = calcDescartes2[i].join("-");
                        attributeName = calcDescartes2[i].join(":");
                    }else {
                        value = calcDescartes2[i];
                        attributeName = calcDescartes2[i];
                    }
                    this.addTable(attributeName,value,calcDescartes2[i]);
                }
            },
            //往表格添加一条数据
            addTable(name,value,calcDescartes2){
                let arr = [];
                if(typeof calcDescartes2 == 'string'){
                    arr.push(calcDescartes2);
                }else{
                    arr = calcDescartes2;
                }
                this.form.tableData.push(
                        {
                            varAttr:name,
                            picUrl:'',
                            commSku:value,
                            price:'',
                            skuPicList:[],
                            attrList:arr,
                        }
                )
            },

            //往表格添加一条数据
            addTable2(id,name,skuId,picUrl,value,price,skuPicList,attrList){
                this.form.tableData.push(
                        {
                            id:id,
                            varAttr:name,
                            skuId:skuId,
                            picUrl:picUrl,
                            commSku:value,
                            price:price,
                            skuPicList:skuPicList,
                            attrList:attrList
                        }
                )
            },
            //隐藏输入框并把值=''
            inputHide(index){
                this.$set(this.form.attributeList[index], 'inputVisible', false)
                this.$set(this.form.attributeList[index], 'attributeValue', '')
            },
            //取消修改
            cancelPrice(){
                this.updateSkuDig = false;
                this.updatePriceDig = false;
                this.prefixSku = null;
                this.suffixSku = null;
                this.price = null;
            },

            //取消修改
            cancelSku(){
                this.updateSkuDig = false;
                this.updatePriceDig = false;
                this.prefixSku = null;
                this.suffixSku = null;
                this.price = null;
            },

            //提交修改SKU
            sumbitSku(){
                let prefixSku = this.prefixSku;
                let suffixSku = this.suffixSku;
                if (prefixSku==null || prefixSku==""){
                    this.msgError("前缀不能为空");
                    return;
                }
                if (suffixSku==null || suffixSku==""){
                    this.msgError("后缀不能为空");
                    return;
                }
                for (var i=0; i<this.form.tableData.length; i++){
                    this.form.tableData[i].commSku=prefixSku+"-"+i+"-"+suffixSku;
                }
                this.cancelSku();
            },
            //提交价格
            sumbitPrice(){
                let price = this.price;
                if (price==null || price==""){
                    this.msgError("价格不能为空");
                    return
                }
                let number = toDecimal(price);
                for (var i=0; i<this.form.tableData.length; i++){
                    this.form.tableData[i].price=number;
                }
                this.cancelPrice();
            },
            //包装尺寸的检验
            limitNumber(e,name){
                if (e!=null && e>100000){
                    if (name=='long'){
                        this.bzyys.formLabelAlign.packLong=100000
                    }else if (name=='wide'){
                        this.bzyys.formLabelAlign.packWide=100000

                    }else if (name=='high'){
                        this.bzyys.formLabelAlign.packHigh=100000
                    }
                }
            },
            //变种图片的上传图片
            skuUploadImg(res,index){
                var formData = new FormData();
                //文件
                formData.append("imageFile", res.file);
                goodsUploadImg(formData).then(res => {
                    if(res.code == 200){
                        this.form.tableData[index].skuPicList.push(
                                {
                                    imgUrl:res.data.img,
                                    picPx:res.data.picPx
                                }
                        )
                        this.msgSuccess(res.msg);
                    }
                }).catch(err => {});
            },

            //删除SKU图片
            deleteSkuImg(tableIndex,imgIndex){
                this.form.tableData[tableIndex].skuPicList.splice(imgIndex,1);
            },
            //删除设计图片
            deleteDesignImg(){
                this.form.design.imgUrl =null;
                this.form.design.picPx =null;
            },
            //上传设计图片
            designUploadImg(res){
                var formData = new FormData();
                //文件
                formData.append("imageFile", res.file);
                goodsUploadImg(formData).then(res => {
                    if(res.code == 200){
                        this.form.design.imgUrl=res.data.img;
                        this.form.design.picPx=res.data.picPx;
                        this.msgSuccess(res.msg);
                    }
                }).catch(err => {});
            },

            loadProductData(typeOption){
            let that = this;
            getAllProductMsg(that.$route.query.pId).then((data) => {
                that.form.proTitle = data.data.sCpCustom.proTitle;
                that.form.engProTitle = data.data.sCpCustom.engProTitle;
                that.form.prodTech = data.data.sCpCustom.prodTech;
                that.form.pdMaterial = data.data.sCpCustom.pdMaterial;
                that.form.packLong = data.data.sCpCustom.packLong;
                that.form.packWide = data.data.sCpCustom.packWide;
                that.form.packWeight = data.data.sCpCustom.packWeight;
                that.form.packHigh = data.data.sCpCustom.packHigh;
                that.form.packVole = data.data.sCpCustom.packVole;
                that.form.description = data.data.sCpCustom.detail=='null'?'':data.data.sCpCustom.detail;
                that.form.size = data.data.sCpCustom.cpSize=='null'?'':data.data.sCpCustom.cpSize;
                that.form.warmTip = data.data.sCpCustom.reminder=='null'?'':data.data.sCpCustom.reminder;
                that.form.price = data.data.sDzSkus != null && data.data.sDzSkus.length>0?data.data.sDzSkus[0].price:null;
                that.form.attribute = data.data.sCpCustom.attribute;//生成变种
                let typeArr = [parseInt(data.data.sCpCustom.typeId)];
                that.form.typeId = this.getParentId(typeOption,typeArr);
                for (var key in data.data.attribute) {
                    this.form.attributeList.push(
                        {
                            attributeName: key,
                            attributeValue: data.data.attribute[key],
                            dynamicTags: data.data.attribute[key],
                            inputVisible: false,
                            inputValue: ''
                        }
                    );
                }

                data.data.sDzSkus.forEach(item =>{
                        var arrList=[];
                        var skuArr=[];

                        const picAttr = data.data.sDzPics.filter(pic =>
                            item.skuid + '' == pic.skuid && pic.isMain=='1'
                        );
                        let picUrl;
                        let id;
                        if (picAttr.length>0) {
                            picUrl= picAttr[0].picUrl;
                            id= picAttr[0].id;
                        }
                        const skuPicList = data.data.sDzPics.filter(pic =>
                                item.skuid + '' == pic.skuid && pic.isMain=='0'
                        );
                        if (skuPicList.length>0) {
                            for (var k=0;k<skuPicList.length;k++){
                                let imgUrl= skuPicList[k].picUrl;
                                let picPx= skuPicList[k].picPx;
                                let id = skuPicList[k].id;
                                skuArr.push({imgUrl:imgUrl,picPx:picPx,id:id});
                            }
                        }

                        var split = item.properVal.split(":");
                        for(var z=0;z<split.length;z++){
                            arrList.push(split[z],split[z+1]);
                        }
                        this.addTable2(id,item.properVal,item.skuid,picUrl,item.skuno,toDecimal(item.price),skuArr,arrList);
                    });
                });
            },

            //根据叶子节点获取上级节点id
            getParentId(arr,ids){
                let tmp = arr.filter(item =>{
                    return item.id == ids[0];
                });
                if(tmp.length > 0 && tmp[0].parentId != 1){
                    ids.unshift(tmp[0].parentId);
                    this.getParentId(arr,ids);
                }
                return ids;


            }
        }
    }
</script>

<style scoped>
    .headerBorder{
        border:1px solid darkgrey;
    }
    .container{
        margin-top: 15px;
    }
    .main{
        border:1px solid darkgrey;
        border-top: none;
        width: 100%;
    }
    .el-header{
        height: 40px;
    }
    .inputSize{
        width: 300px;
    }
    .image {
        width: 88px;
        display: block;
        height: 100px;
    }


</style>
<style>
    #cardStyle .el-upload--picture-card {
        width: 115px;
        height: 100px;
    }

</style>

